import { render } from "./ReportesFiltros_pdf_salida.vue?vue&type=template&id=0cee72f2&bindings={\"breadcrumbA\":\"data\",\"breadcrumbB\":\"data\",\"descripcion\":\"data\",\"triggers\":\"data\",\"personal\":\"data\",\"obtenerPersonal\":\"options\",\"refrescarPersonal\":\"options\"}"
import script from "./ReportesFiltros_pdf_salida.vue?vue&type=script&lang=js"
export * from "./ReportesFiltros_pdf_salida.vue?vue&type=script&lang=js"

import "./ReportesFiltros_pdf_salida.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script